import { useEffect } from 'react';
import { useUserProfileInfo } from '@/entities/user';
import { useAppSettingsStore, useZohoChat } from '@/shared/lib';
import { useSessionStore } from '@/entities/session';
import type { Language } from '@/shared/types';

// Extend Window interface to include Zoho Chat interface
declare global {
  interface ZohoSalesIQ {
    chat?: { start: () => void };
    floatwindow?: { visible: (state: 'show' | 'hide') => void };
    reset?: () => void;
    visitor?: {
      firstname: (value: string) => void;
      lastname: (value: string) => void;
      email: (value: string) => void;
      contactnumber: (value: string) => void;
      info: (data: Record<string, string>) => void;
    };
    language?: (code: Language) => void;
  }

  interface Window {
    $zoho?: {
      salesiq?: ZohoSalesIQ;
    };
  }
}

export const ZohoChatSync = () => {
  const { session } = useSessionStore();
  const { userProfileInfoMap } = useUserProfileInfo();

  const { theme, getLanguage } = useAppSettingsStore();
  const language = getLanguage();

  const { reset, setVisitor, setZohoWidgetLanguage } = useZohoChat();

  useEffect(() => {
    setZohoWidgetLanguage(language);
  }, [language, session]);

  useEffect(() => {
    const zoho = window.$zoho?.salesiq;

    if (!zoho) return;

    if (session) {
      if (userProfileInfoMap.phone && language) {
        setVisitor({
          ...userProfileInfoMap,
          theme: theme || 'light',
          language,
          isAuthenticated: !!session,
        });
      }
    } else {
      reset();
    }
  }, [session, userProfileInfoMap.firstName, language]);

  return null;
};
